<template>
  <div class="func-options">
    <div>
<!--      `/${funcionalidade.idFuncionalidade}/novo` }-->
      <dashItem
          v-if="rotaNovo && permiteNovo"
          :link="{ path: rotaNovo }"
          icon="el-icon-circle-plus-outline"
          title="Nova solicitação"
      />
<!--      /${funcionalidade.idFuncionalidade}/historico` }-->
      <dashItem
          v-if="rotaHistorico"
          :link="{ path: rotaHistorico }"
          icon="el-icon-add-location"
          title="Histórico"
      />
    </div>
    <div class="clearfix"/>
  </div>
</template>
<script>
import DashItem from '@/components/dashboard/DashItem.vue'

export default {
  name: 'SolicitacaoListagemHeader',
  components: { DashItem },
  props: {
    rotaNovo: {
      type: String,
      default: ''
    },
    permiteNovo: {
      type: Boolean,
      default: true
    },
    rotaHistorico: {
      type: String,
      default: ''
    }
  }
}
</script>
